import { Header } from "@/components/Header";
import { Hero, HERO_IMG } from "@/components/Hero";
import { ServiceArea } from "@/components/ServiceArea";
import { Gallery } from "@/components/Gallery";
import { Estimate } from "@/components/Estimate";
import { WorkCarousel } from "@/components/WorkCarousel";
import { Footer } from "@/components/Footer";

export default function Home() {
  return (
    <main data-testid="home-page" className="relative overflow-x-clip">
      <div className="fixed inset-0 -z-10 bg-white" aria-hidden="true">
        <img src={HERO_IMG} alt="" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-[linear-gradient(to_bottom,#ffffff_0%,rgba(255,255,255,0.92)_12%,rgba(255,255,255,0.72)_30%,rgba(255,255,255,0.55)_55%,rgba(255,255,255,0.45)_100%)]" />
      </div>
      <Header />
      <Hero />
      <div className="relative z-10 -mt-24 pb-8 sm:-mt-32">
        <WorkCarousel />
      </div>
      <div className="border-t border-black/10" aria-hidden="true" />
      <Estimate />
      <ServiceArea />
      <Gallery />
      <Footer />
    </main>
  );
}
